module.exports = __webpack_public_path__ + "static/media/canais-banner.aed31f6d.jpg";